import { render } from "./ImCompany.vue?vue&type=template&id=b2510386&scoped=true"
import script from "./ImCompany.vue?vue&type=script&lang=js"
export * from "./ImCompany.vue?vue&type=script&lang=js"

import "./ImCompany.vue?vue&type=style&index=0&id=b2510386&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-b2510386"

export default script